(() => {
  if (customElements.get("attentive-button")) {
    return;
  }

  class AttentiveButton extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector("a");
      if (!button) return;

      button.addEventListener("click", (e) => {
        e.preventDefault();
        if (window.outerWidth > 767) {
          window.__attentive.trigger(null, null, null, this.dataset.desktopId);
        } else {
          window.__attentive.trigger(null, null, null, this.dataset.mobileId);
        }
      });
    }
  }

  customElements.define("attentive-button", AttentiveButton);
})();
